import mixpanel from "mixpanel-browser";

import { isLocalHost } from "../common/utils/isLocalHost";
import { dynamicConfig } from "../config/dynamicConfigs";

const sessionIdKey = "Session ID";
const lastEventTimeKey = "Last Event Time";

export const specialSuperProperties = {
  sessionIdKey, // Session ID
  lastEventTimeKey, // Last Event Time
};

// thirty minutes in milliseconds
export const sessionTimeout = 1800000;

const mixPanelSessionConfig = {
  timeout: sessionTimeout,

  getSessionId: () => {
    const s4 = () =>
      Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);

    return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
  },

  // set a new session id
  setSessionId: () => {
    mixpanel.register({
      [sessionIdKey]: mixPanelSessionConfig.getSessionId(),
    });
  },

  // check for a new session id
  checkSessionId: () => {
    // check #1 do they have a session already?
    if (!mixpanel.get_property(lastEventTimeKey)) {
      mixPanelSessionConfig.setSessionId();
    }

    if (!mixpanel.get_property(sessionIdKey)) {
      mixPanelSessionConfig.setSessionId();
    }

    // check #2 did the last session exceed the timeout?
    if (Date.now() - mixpanel.get_property(lastEventTimeKey) > mixPanelSessionConfig.timeout) {
      mixPanelSessionConfig.setSessionId();
    }
  },
};

const testEnv = "dcd54e9c8c06304bb24528bdc0219a5d";
const prodEnv = "b3ba44cb28d6ad61d9056b62493f0fb6";
const id = dynamicConfig.isProduction ? prodEnv : testEnv;

mixpanel.init(id, {
  debug: dynamicConfig.analyticsDebug,
  loaded(mixpanel) {
    mixPanelSessionConfig.checkSessionId();

    const originalTrack = mixpanel.track;
    mixpanel.track = (...rest) => {
      mixPanelSessionConfig.checkSessionId();
      mixpanel.register({ [lastEventTimeKey]: Date.now() });
      originalTrack.apply(mixpanel, rest);
    };
  },
});

export const MixPanel = !isLocalHost || process.env.NODE_ENV === "development" ? mixpanel : null;
